import { Browser } from "@capacitor/browser";
import { Capacitor } from "@capacitor/core";

function getPickupAddress(order) {
  return [
    order?.pickup_location_detail || order?.pickup_location || order?.pickup_area,
    order?.pickup_terminal,
    order?.flight_number,
  ].filter(Boolean).join(" ");
}

function getDropoffAddress(order) {
  return [
    order?.dropoff_location_detail || order?.destination || order?.dropoff_area || order?.end_location,
    order?.dropoff_terminal,
  ].filter(Boolean).join(" ");
}

export function buildGoogleMapsUrl(order, target = "route") {
  const pickup = getPickupAddress(order);
  const dropoff = getDropoffAddress(order);
  if (target === "pickup" || !dropoff) {
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(pickup)}`;
  }
  if (target === "dropoff" || !pickup) {
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(dropoff)}`;
  }
  const origin = encodeURIComponent(pickup);
  const destination = encodeURIComponent(dropoff);
  return `https://www.google.com/maps/dir/?api=1&origin=${origin}&destination=${destination}&travelmode=driving`;
}

export function buildAppleMapsUrl(order, target = "route") {
  const pickup = getPickupAddress(order);
  const dropoff = getDropoffAddress(order);
  if (target === "pickup" || !dropoff) {
    return `maps://?q=${encodeURIComponent(pickup)}`;
  }
  if (target === "dropoff" || !pickup) {
    return `maps://?q=${encodeURIComponent(dropoff)}`;
  }
  return `maps://?saddr=${encodeURIComponent(pickup)}&daddr=${encodeURIComponent(dropoff)}&dirflg=d`;
}

export function buildGoogleMapsAppUrl(order, target = "route") {
  const pickup = getPickupAddress(order);
  const dropoff = getDropoffAddress(order);
  if (target === "pickup" || !dropoff) {
    return `comgooglemaps://?q=${encodeURIComponent(pickup)}`;
  }
  if (target === "dropoff" || !pickup) {
    return `comgooglemaps://?q=${encodeURIComponent(dropoff)}`;
  }
  return `comgooglemaps://?saddr=${encodeURIComponent(pickup)}&daddr=${encodeURIComponent(dropoff)}&directionsmode=driving`;
}

export function buildYahooMapsUrl(order,target='pickup',native=false){
 const address=target==='dropoff'?getDropoffAddress(order):getPickupAddress(order);
 return native?'yjmap://search?q='+encodeURIComponent(address):'https://map.yahoo.co.jp/?q='+encodeURIComponent(address);
}

function openNativeUrl(url) {
  window.location.assign(url);
}

export async function openMapsForOrder(order, target = "route", provider = "apple") {
  const fallbackUrl = provider==='yahoo'?buildYahooMapsUrl(order,target):buildGoogleMapsUrl(order, target);
  if (Capacitor.isNativePlatform()) {
    const url = provider === "yahoo" ? buildYahooMapsUrl(order,target,true) : provider === "google" ? buildGoogleMapsAppUrl(order, target) : buildAppleMapsUrl(order, target);
    openNativeUrl(url);
    if (provider === "google" || provider === "yahoo") {
      window.setTimeout(() => {
        if (document.visibilityState === "visible") {
          Browser.open({ url: fallbackUrl }).catch(() => window.location.assign(fallbackUrl));
        }
      }, 900);
    }
    return { status: "opened_native_app", provider, url, fallbackUrl };
  }
  window.open(fallbackUrl, "_blank", "noopener,noreferrer");
  return { status: "opened_web", provider: "google_web", url: fallbackUrl };
}

export async function openGoogleMapsForOrder(order, target = "route") {
  return openMapsForOrder(order, target, "google");
}
